import { BASIC_INITIAL_STATE } from '../../utils/HttpHelper';
import { API_NAMES, initApi } from '../../utils/HttpApiHelper';

const postCustomerSatisfactionData = (customerSatisfactionObj, state, setState) => {
  if (customerSatisfactionObj) {
    const api = initApi(API_NAMES.COMMON, state, setState);
    const url = `/CustomerSatisfaction`;

    return api?.executeObject ? api.executeObject(url, 'POST', customerSatisfactionObj) : null;
  }
};

const putCustomerSatisfactionData = (customerSatisfactionId, customerSatisfactionObj, state, setState) => {
  if (customerSatisfactionId > 0) {
    const api = initApi(API_NAMES.COMMON, state, setState);
    const customerSatisfactionIdForUrl = encodeURIComponent(customerSatisfactionId);
    const url = `/CustomerSatisfaction/${customerSatisfactionIdForUrl}`;

    return api?.executeObject ? api.executeObject(url, 'PUT', customerSatisfactionObj) : null;
  }
};

const CustomerSatisfactionData = {
  INITIAL_STATE: BASIC_INITIAL_STATE,
  postCustomerSatisfactionData,
  putCustomerSatisfactionData
};

export default CustomerSatisfactionData;
